import { Dictionary } from 'lodash';

import { MyWorkspaceWidgetNames } from '../Widgets/data/widgets';

export interface LayoutBreakpoint {
  minWidth: number;
  cols: number;
  canResize: boolean;
  canReorder: boolean;
}

export const layoutBreakpoints: LayoutBreakpoint[] = [
  { minWidth: 1500, cols: 6, canResize: true, canReorder: true },
  { minWidth: 1200, cols: 5, canResize: true, canReorder: true },
  { minWidth: 996, cols: 4, canResize: true, canReorder: true },
  { minWidth: 768, cols: 3, canResize: true, canReorder: true },
  { minWidth: 480, cols: 2, canResize: false, canReorder: false },
  { minWidth: 0, cols: 1, canResize: false, canReorder: false },
];

export interface WidgetSizeLimit {
  maxW?: number;
  maxH?: number;
  minW?: number;
}

export const widgetsSizeLimits: Dictionary<WidgetSizeLimit> = {
  [MyWorkspaceWidgetNames.AnnouncementsWidget]: { maxW: 3, maxH: 2 },
};

export interface WidgetDefaultSize {
  w: number;
  h: number;
}

export const widgetsDefaultSize: Dictionary<WidgetDefaultSize> = {
  [MyWorkspaceWidgetNames.MyTeamAbsencesWidget]: { w: 2, h: 1 },
  [MyWorkspaceWidgetNames.TeamCompensationWidget]: { w: 2, h: 1 },
  [MyWorkspaceWidgetNames.ApprovalWidget]: { w: 2, h: 1 },
  [MyWorkspaceWidgetNames.AnnouncementsWidget]: { w: 2, h: 2 },
  [MyWorkspaceWidgetNames.TeamPerformanceWidget]: { w: 2, h: 1 },
  [MyWorkspaceWidgetNames.MyPerformanceWidget]: { w: 2, h: 1 },
};
